export const normalizeConciliationStatus = status =>
  String(status || '')
    .replace(/\s*undefined\s*/gi, '')
    .trim()
    .toUpperCase()

export const getConciliationDisplayStatus = (rowStatus, parentStatus, isSelected) => {
  const normalizedRowStatus = normalizeConciliationStatus(rowStatus)
  if (normalizedRowStatus && normalizedRowStatus !== '-') return normalizedRowStatus
  if (!isSelected) return ''

  const normalizedParentStatus = normalizeConciliationStatus(parentStatus)
  const supportedStatuses = [
    'PARCIALMENTE COBRADO',
    'PARCIALMENTE PAGADO',
    'PARCIALMENTE CONCILIADO',
    'COBRADO',
    'PAGADO',
    'CONCILIADO'
  ]

  return supportedStatuses.find(status => normalizedParentStatus.includes(status)) || ''
}
